// extracted by mini-css-extract-plugin
export default {"list":"SelectTemplatesDialog_list__NE0YA"};